export default {"src":"/_next/static/media/icon_compare_default.39e8d8aa.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};